import { Typography } from "@mui/material"
import { Grid } from "@mui/system"
import React from "react"
import { MUIDateTimePicker } from "../dateTimePicker/dateTimePicker"
import { useTranslation } from "react-i18next"
import localizationKeys from "../../i18n/localizationKeys"
import PropTypes from "prop-types"

export const MUIDurationPicker = ({isSEPVessel, startDate, setStartDate, endDate, setEndDate, disabled = false}) => {
  const {t} = useTranslation();
  return(
    <>
      <Grid container spacing={2} sx={{width: '100%'}}>
        <Grid size={6}>
          <Typography color="white" fontSize={12}>{t(localizationKeys.StartTime)}</Typography>
          <MUIDateTimePicker isSEPVessel={isSEPVessel} date={startDate} setDateFunction={(d) => setStartDate(d)} isStart={true} limitationDate={endDate} disabled={disabled}/>
        </Grid>
        <Grid size={6}>
          <Typography color="white" fontSize={12}>{t(localizationKeys.EndTime)}</Typography>
          <MUIDateTimePicker isSEPVessel={isSEPVessel} date={endDate} setDateFunction={(d) => setEndDate(d)} isStart={false} limitationDate={startDate} disabled={disabled}/>
        </Grid>
      </Grid>
    </>
  )
}

MUIDurationPicker.propTypes = {
  isSEPVessel: PropTypes.bool,
  startDate: PropTypes.object,
  setStartDate: PropTypes.func,
  endDate: PropTypes.object,
  setEndDate: PropTypes.func,
  disabled: PropTypes.bool
}